<template>
    <el-card style="min-height: calc(100vh - 25vh);">

        <div class="mask" v-if="showImg" @click="showImg = false"></div>
            <!-- @submit.prevent="fetchMember" -->
        <form
            class="pb-6 reception-form flex">
            <div class="flex form-select">
                <div class="flex items-center">
                    <span class="label">{{ $t('Common.store_tip') }}</span>
                    <el-select
                        class="pr-2 reception-store"
                        v-model="memberForm.storeId"
                        v-on:change="temLockerId = null;locker = [];"
                        :placeholder="$t('Common.store_placeholder')">
                        <el-option
                            v-for="(item, index) in stores"
                            :key="`${index}-${item.id}`"
                            :label="item.name"
                            :value="Number(item.id)">
                        </el-option>
                    </el-select>
                </div>
                <el-input
                    @keyup.enter.native="fetchMember()"
                    class="reception-nickname"
                    v-model="memberForm.keyword"
                    :placeholder="$t('Common.client_tip')">
                </el-input>
                <div class="pl-2">
                    <el-button
                        type="primary"
                        @click="fetchMember()"
                    >{{ $t('Common.search') }}</el-button>
                </div>

                <!-- 二维码图片显示 -->

                <div class="pl-2" style="position: relative">
                    <!-- <img style="position: absolute;right: 0;" src="../../../assets/images/qr.png" alt=""> -->
                    <!-- 扫码二维码 -->
                    <el-input
                        style="z-index: -1;position: absolute;opacity: 0;width: 200px;"
                        @change="fetchCode()"
                        ref="code"
                        v-model="code">
                    </el-input>

                    <div
                        @click="showImg = false"
                        v-if="showImg"
                        style="
                        position: absolute;
                        width: 190px;
                        top: calc(100% + 18px);
                        left: 50%;
                        transform: translate(-50%, 0);">
                        <img src="../../../assets/images/qr.png" alt="">
                    </div>

                    <el-button
                        slot="reference"
                        type="success"
                        @click="scanCode"
                    >{{ $t('Common.scan_code') }}</el-button>

                </div>

            </div>
            <div class="flex items-center form-search-wrap">
                <span class="label-2">{{ $t('Reception.First.temporary') }}</span>
                <el-select
                    style="width: 100%;"
                    v-model="temLockerId"
                    filterable
                    remote
                    reserve-keyword
                    :placeholder="$t('Reception.First.temporary_placeholder')"
                    :remote-method="fetchTemLocker">
                    <el-option
                        v-for="item in locker"
                        :key="item.id"
                        :label="item.lockerCode"
                        :value="item.id">
                    </el-option>
                </el-select>
                <div class="pl-2">
                    <el-button
                        @click="handleEnter"
                        type="primary"
                    >{{ $t('Reception.First.sign') }}</el-button>
                </div>
                <div class="pl-2">
                    <el-button
                        @click="handleLeave"
                        type="success"
                    >{{ $t('Reception.First.out') }}</el-button>
                </div>
                <div class="pl-2">
                    <el-button
                        @click="handleResetMember"
                    >{{ $t('Common.cancel') }}</el-button>
                </div>
            </div>
        </form>

        <!-- 数据 -->
        <el-form v-loading="loading">
            <div class="reception-member" v-show="hasMember">
                <div class="member-info">
                    <div class="member-title">{{ $t('Common.base_info') }}</div>
                    <div class="member-info-content">
                        <div>
                            {{ $t('Common.card_number') }}：{{ memberInfo.cardNum }}
                        </div>
                        <div>{{ $t('Common.name') }}：
                            <span
                                @click="userDetails"
                                class="fitness-blue cursor-pointer">
                                {{ memberInfo.name }}
                            </span>
                        </div>
                        <div>{{ $t('Common.phone') }}：{{ memberInfo.phone }}</div>
                        <div>{{ $t('Common.number_type') }}：{{ memberInfo.type }}</div>
                        <div>{{ $t('Reception.First.temporary') }}：{{ memberInfo.temLockerCodes }}</div>
                        <div>{{ $t('Reception.First.consultant') }}：{{ memberInfo.memberShipAdviser }}</div>
                        <div>{{ $t('Common.follow_coach') }}：{{ memberInfo.followCoachName }}</div>
                        <div class="member-info-remarks">
                            <div class="flex flex-column" v-for="(item, index) in memberInfo.rentalLockers" :key="index">
                                <span class="mb-4">{{ $t('Common.cabinet_number') }}：{{ item.lockerCode }}</span>
                                <span class="mb-4">{{ $t('Common.cabinet_time') }}：{{ item.lockerDate }}</span>
                            </div>
                            <div>{{ $t('Common.remark') }}：{{ memberInfo.remark }}</div>
                        </div>
                    </div>
                </div>
                <div class="member-avator">
                    <div class="member-title flex items-center justify-between">
                        <div>{{ $t('Reception.First.picture') }}</div>
                        <div class="flex">
                            <!--<div @click="onCamera" style="margin-right: 15px;" class="iconfont icon-fitness-camera">
                            </div>-->
                            <file-upload is_avatar="reception" @input="addImg(arguments)">
                                <div class="iconfont icon-fitness-shangchuan"></div>
                            </file-upload>
                        </div>
                    </div>
                    <div class="member-avator-pic">
                        <div
                            :style="`background-image: url(${memberInfo.avatar})`"
                            class="member-avator-bg"></div>
                        <div
                            v-if="!memberInfo.avatar"
                            class="member-avator-icon iconfont icon-fitness-touxiang2 absolute"></div>
                    </div>
                </div>
                <div class="member-desc">
                    <div class="member-desc-item">
                        <div class="member-title">{{ $t('Reception.First.info') }}</div>
                        <div class="member-membership">
                            <table class="client-registration-table">
                                <thead>
                                    <tr>
                                        <td>{{ $t('Reception.First.choose') }}</td>
                                        <td>{{ $t('Reception.First.card_name') }}</td>
                                        <td>{{ $t('Reception.First.validity') }}</td>
                                        <td>{{ $t('Reception.First.remaining') }}</td>
                                        <td>{{ $t('Reception.First.support_store') }}</td>
                                        <td
                                            style="width: 35px;"
                                        >{{ $t('Reception.First.enter_time') }}</td>
                                        <td>{{ $t('Reception.First.frequency') }}</td>
                                    </tr>
                                </thead>
                                <tbody id="tby">
                                    <template v-for="(item, index) in membershipData">
                                        <tr :key="index">
                                            <td rowspan="2">
                                                <el-radio v-model="clickItem" :label="item"></el-radio>
                                            </td>
                                            <td>{{ item.cardName }}</td>
                                            <td>{{ item.validityPeriod }}</td>
                                            <td>{{ item.balance }}</td>
                                            <td>{{ item.supportedStores }}</td>
                                            <td>{{ item.enterTimes }}</td>
                                            <td>
                                                <span v-if="Number(item.cardType) === 2">--</span>
                                                <div v-if="Number(item.cardType) === 3">
                                                    <el-input
                                                        style="width: 48px;"
                                                        v-model="deduction">
                                                    </el-input>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr :key="`remark${index}`">
                                            <td colspan="6">{{ $t('Common.remark') }}：{{ item.remark }}</td>
                                        </tr>
                                    </template>
                                </tbody>
                                <tbody v-if="!membershipData.length">
                                    <tr>
                                        <td
                                            class="client-table-none"
                                            colspan="7"
                                        >{{ $t('Common.none_data') }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="member-desc-item">
                        <div class="member-title">{{ $t('Common.appointment_info') }}</div>
                        <div class="member-membership">
                            <el-table
                                :data="appointments"
                                style="width: 100%;margin: 15px 0;"
                                border>
                                <el-table-column prop="lessonTime" :label="$t('Common.time')" />
                                <el-table-column prop="lessonName" :label="$t('Common.lesson')" />
                                <el-table-column prop="coachName" :label="$t('Common.coach')" />
                            </el-table>
                        </div>
                    </div>
                    <div class="member-desc-item">
                        <div class="member-title">{{ $t('Reception.First.enter_info') }}</div>
                        <div class="member-membership">
                            <el-table
                                :data="admissionInfo"
                                style="width: 100%;margin: 15px 0;"
                                border>
                                <el-table-column prop="storeName" :label="$t('Common.enter_store')" />
                                <el-table-column prop="enterTime" :label="$t('Common.enter_time')" />
                                <el-table-column prop="leaveTime" :label="$t('Common.outer_time')" />
                                <el-table-column
                                    prop="temporaryLocker"
                                    :label="$t('Reception.First.temporary')">
                                    <template slot-scope="{row}">
                                        <div v-if="row.temporaryLocker">
                                            {{ row.temporaryLocker }}
                                            <span
                                                class="cursor-pointer"
                                                @click="handleTemlock(row)"
                                                :class="{'fitness-blue': Number(row.temLockerStatusCode) === 2}">
                                                {{ `(${row.temLockerStatus})` }}
                                            </span>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </el-form>

    </el-card>
</template>

<script>
import FileUpload from '@/components/base/FileUpload';
import { Radio } from 'element-ui';

export default {
    name: 'lientRegistration',
    components: {
        ElRadio: Radio,
        FileUpload,
    },
    data() {
        return {
            memberForm: {
                storeId: '',
                keyword: '',
            },
            temLockerId: null,
            locker: [],
            stores: [],
            hasMember: false,
            memberInfo: {},
            admissionInfo: [],
            appointments: [],
            membershipData: [],
            clickItem: null,
            deduction: 1,
            code: null,
            loading: false,

            showImg: false,
        };
    },
    created() {
        this.fetchStore();
    },
    methods: {
        scanCode() {
            // 初始化code
            this.code = null;
            this.$nextTick(() => {
                this.$refs.code.focus();
                this.showImg = true;
            });
        },
        addImg(args) {
            const id = this.memberInfo.id;
            API.put(`client/${id}/avatar`, {
                avatar: args[0],
            }).then(res => {
                if (res) this.memberInfo.avatar = res.avatar;
            });
        },
        handleResetMember(type) {
            if (!type) this.memberForm.keyword = '';
            this.memberInfo = {};
            this.clickItem = null;
            this.admissionInfo = [];
            this.appointments = [];
            this.membershipData = [];
            this.deduction = 1;
            this.temLockerId = null;
            this.hasMember = false;
        },
        fetchStore() {
            // 门店
            API.get('store/list').then(res => {
                this.stores = res;
                this.memberForm.storeId = this.memberForm.storeId || res[0].id;
            });
        },
        // 临时储物柜
        fetchTemLocker(val = '') {
            API.get('temporary-locker', {
                params: {
                    lockerCode: val,
                    storeId: this.memberForm.storeId,
                },
            }).then(res => {
                this.locker = res;
            });
        },
        fetchMember() {
            this.loading = true;
            API.get('admission/client', {
                params: this.memberForm,
            }).then(res => {
                this.memberInfo = res.baseClientInfo;
                this.membershipData = res.memberShips;
                this.clickItem = res.memberShips[0];
                this.appointments = res.reservations;
                this.admissionInfo = res.entrances;
                this.hasMember = true;
            }).catch((err) => {
                this.handleResetMember('keyword');
            }).finally(() => this.loading = false);
        },
        // 入场
        handleEnter() {
            if (!this.hasMember) return $ele.$message(this.$t('Reception.First.choose_member'));
            const form = {
                clientId: this.memberInfo.id,
                temLockerId: this.temLockerId,
                storeId: this.memberForm.storeId,
                contractNum: this.clickItem.contractNum,
                deduction: this.memberInfo.cardType === 2 ? 1 : this.deduction,
            };
            API.put('admission/enter', form).then(res => {
                $ele.$message.success(this.$t('Message.success'));
                this.handleResetMember();
            }).catch((err) => {
                // 添加提前开卡接口
                if (err.code === 412) {
                    $ele.$confirm(err.message, this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        cancelButtonText: this.$t('Common.cancel'),
                        type: 'warning'
                    }).then(res => {
                        this.advanceOpen();
                    }).catch(() => {});
                }
            });
        },
        // 提前开卡
        advanceOpen() {
            API.put(`admission/active/${this.clickItem.contractNum}`).then(() => {
                this.handleEnter();
            });
        },
        // 离场
        handleLeave() {
            if (!this.hasMember) return $ele.$message(this.$t('Reception.First.choose_member'));
            const form = {
                clientId: this.memberInfo.id,
                temLockerId: this.temLockerId,
            };
            API.put('admission/leave', form).then(res => {
                $ele.$message.success(this.$t('Message.success'));
                this.handleResetMember();
            });
        },
        // 归还储物柜
        handleTemlock(row) {
            if (Number(row.temLockerStatusCode) !== 2) return;
            const id = row.temLockerId;
            const msg = `${this.$t('Message.temporary_whether')}${row.temporaryLocker}？`;
            $ele.$confirm(msg, this.$t('Message.tip_title'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                API.put(`temporary-locker/return/${id}`).then(() => {
                    $ele.$message.success(this.$t('Message.return_success'));
                    this.fetchMember();
                });
            }).catch(() => {
                // $ele.$message.info('已取消删除');
            });
        },
        // 会员跳转
        userDetails() {
            const activeName = this.memberInfo.typeCode === '1' ? 'first' : 'second';
            this.$router.push({
                name: 'Client',
                query: {
                    clientId: this.memberInfo.id,
                    activeName: activeName,
                },
            });
        },
        async fetchCode() {
            this.$refs.code.blur();
            await API.get('admission/crm/client-phone', {
                params: {
                    QRCodeUrl: this.code
                },
            }).then(res => {
                this.memberForm.keyword = res;
            }).finally(() => {
                this.showImg = false;
            });
            this.fetchMember();
        },
    },
};
</script>

<style lang="scss">
.mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.form-search-wrap {
    .el-select .el-input__inner {
        cursor: text;
    }
}
.client-registration-table {
    width: 100%;
    color: #4c4c4c;
    border: 1px solid #e6e6e6;
    border-radius: 3px;
    background: #fff;
    tr {
        text-align: left;
    }
    td {
        font-size: 13px;
    }
    td {
        height: 20px;
        padding: 10px;
        border-left: 1px solid #e6e6e6;
        border-top: 1px solid #e6e6e6;
        color: grey;
        &:first-child {
            border-left: none;
        }
    }
    tr {
        border-bottom: 1px solid #e6e6e6;
    }
    thead {
        td {
            font-size: 11.5px;
            font-weight: 500;
            border-top: none;
        }
    }
    .client-table-none {
        padding: 22px 0;
        color: #909399;
        font-size: 12px;
        text-align: center;
    }
    tbody {
        tr:nth-child(2n) {
            td {
                border-left: 1px solid#e6e6e6;
            }
        }
    }
}
</style>
